<template>
    <App>
      <AppBar style="width:100%">
        <AppTitle icon="nbgz" name="任吾行 - AI扩展" />
        <AppTabs :items="items" :actived="actived" @on-click="handleClick"/>
        <div></div>
      </AppBar>
      <AppClient style="overflow:hidden;">
      <router-view>
      </router-view>
    </AppClient>
    </App>
  </template>

<script>
import App from '@/components/app/app';
import AppBar from '@/components/app/bar';
import AppTitle from '@/components/app/title';
import AppClient from '@/components/app/client';
import AppTabs from '@/components/app/tabs';
export default {
  routerOption: {
    as_frame: true,
  },
  computed: {
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },
    session() {
      return this.$store.getters['session/session'];
    },
    items() {
      const normal = [{
        icon: 'md-speedometer',
        name: '数据总览',
        key: 'dashboard',
      }, {
        icon: 'md-cube',
        name: '数据提取',
        key: 'dbtool',
      }];
      return normal;
    },
  },
  components: {App, AppBar, AppClient, AppTitle, AppTabs},
  methods: {
    handleClick(e) {
      this.RouteTo(e);
    },
  },
};
</script>

  <style>

  </style>
